export default __webpack_public_path__ + "static/media/ESD.7c4bd55b.jpg";